import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { generateMergeSuggestions } from '../common/Helpers';

const MergeStudentsSection = ({ studentsA, studentsB, suggestions, onSuggestionChange }) => {
  const mergeSuggestions = useMemo(() => generateMergeSuggestions(studentsA, studentsB),
    [studentsA, studentsB]);

  const handleSuggestionToggle = (studentBId) => {
    const current = (suggestions[studentBId] || {}).merge || false;
    const suggestion = mergeSuggestions.find(s => s.studentB.id === studentBId);
    onSuggestionChange(studentBId, {
      merge: !current,
      mergeWith: !current && suggestion ? suggestion.studentA.id : null,
    });
  };

  const isMerging = (studentBId) => (suggestions[studentBId] || {}).merge || false;

  return (
    <div className="merge-students-section">
      <h5>Uczniowie do scalenia</h5>
      <p className="text-muted small">
        System sugeruje scalenie uczniów o tym samym imieniu.
      </p>

      {mergeSuggestions.length === 0 && studentsB.length === 0 && (
        <p className="text-muted">Brak uczniów do przeniesienia.</p>
      )}

      <div className="list-group">
        {mergeSuggestions.map(suggestion => (
          <div key={suggestion.studentB.id} className="list-group-item d-flex justify-content-between align-items-center">
            <div>
              <strong className="text-primary">
                {suggestion.studentA.firstName} {suggestion.studentA.lastName || ''} (z A)
              </strong>
              {' + '}
              <strong className="text-secondary">
                {suggestion.studentB.firstName} {suggestion.studentB.lastName || ''} (z B)
              </strong>
              {suggestion.studentA.additionalInfo && suggestion.studentB.additionalInfo && (
                <small className="text-muted d-block mt-1">
                  Dane: {suggestion.studentA.additionalInfo} + {suggestion.studentB.additionalInfo}
                </small>
              )}
            </div>
            <button
              type="button"
              className={`btn btn-sm ${isMerging(suggestion.studentB.id) ? 'btn-success' : 'btn-outline-primary'}`}
              onClick={() => handleSuggestionToggle(suggestion.studentB.id)}
            >
              {isMerging(suggestion.studentB.id) ? '✓ Będą scaleni' : 'Nie będą scaleni'}
            </button>
          </div>
        ))}

        {studentsB
          .filter(studentB => !mergeSuggestions.find(s => s.studentB.id === studentB.id))
          .map(student => (
            <div key={student.id} className="list-group-item d-flex justify-content-between align-items-center">
              <div>
                <strong className="text-secondary">
                  {student.firstName} {student.lastName || ''} (tylko z B)
                </strong>
                {student.additionalInfo && (
                  <small className="text-muted d-block mt-1">
                    Dane: {student.additionalInfo}
                  </small>
                )}
              </div>
              <span className="badge bg-secondary">Przenieś do A</span>
            </div>
          ))
        }
      </div>
    </div>
  );
};

MergeStudentsSection.propTypes = {
  studentsA: PropTypes.array.isRequired,
  studentsB: PropTypes.array.isRequired,
  suggestions: PropTypes.object.isRequired,
  onSuggestionChange: PropTypes.func.isRequired,
};

export default MergeStudentsSection;
